import { sortByStringField } from 'commons/utils/sort.utils';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import { SettingsSideBarItemMenu } from 'modules/settings/components/side-menu-list';
import { DEVICE_TYPES_WITH_SETTINGS } from './settings-devices-configuration/settings-devices-configuration.constant';

export const hasDeviceSettings = (deviceType: DeviceTypeDetails): boolean =>
    DEVICE_TYPES_WITH_SETTINGS.has(deviceType.name);

export const sortMenuOptionsByTitle = (options: SettingsSideBarItemMenu[]): SettingsSideBarItemMenu[] =>
    sortByStringField(options, { title: 'asc' }, 'title');
